export const endpoints = {
  searchImportSets: 'importSet/search',
  deleteImportSetItem: 'importSet',
  copyImportSetOptions: 'importSet/options'
};
